import { render, staticRenderFns } from "./SubFormStore.vue?vue&type=template&id=65519d20&scoped=true"
import script from "./SubFormStore.vue?vue&type=script&lang=js"
export * from "./SubFormStore.vue?vue&type=script&lang=js"
import style0 from "./SubFormStore.vue?vue&type=style&index=0&id=65519d20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_lodash@4.17.21_prettier@3.5.3_react@19.0.0_vue-template-c_l4y5rdbexcxjh5nqfbzyfvj2aq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65519d20",
  null
  
)

export default component.exports